import Profile from "@/components/Profile";
import { useAppSelector } from "@liberty-fund/data-context/hooks";
import type { AccountState } from "@liberty-fund/data-context/types";
import { Logger } from "@liberty-fund/logger";

export default function Debug() {
  Logger.debug(">>>>>>>>>>>>>>>>> DEBUG page");
  const { user } = useAppSelector<AccountState>((state) => state.account);

  return (
    <main className="p-4">
      <h1 className="text-5xl font-bold border-b border-lf-blue-dark pb-3">
        Welcome {!!user && <span>{user.nickname}</span>} to Liberty Fund
      </h1>
      {!user ? (
        <p className="text-lf-blue-dark py-6">Please login.</p>
      ) : (
        <Profile />
      )}
    </main>
  );
}
